  <div class="content-container app-page mat-app-background">


  @if (this._flowitems!=null && this._flowitems.length==0) {
    <div style="font-family: Roboto; margin: 20px;;">
      NO ITEMS FOUND
    </div>
  }


  <div class="filter-bar">
    <mat-form-field appearance="outline" class="filter-input">
      <mat-label>{{ 'SEARCH.FLOW_FILTER_LABEL' | translate }}</mat-label>
      <input matInput [(ngModel)]="filterText" (keyup.enter)="onSearch()" placeholder="{{ 'SEARCH.FLOW_FILTER_PLACEHOLDER' | translate }}" />
      @if (filterText) {
        <button matSuffix mat-icon-button (click)="onClearSearch()" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      }
      <button matSuffix mat-icon-button (click)="onSearch()" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>


  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" style="margin-top: 1px;" ></mat-progress-bar>
  }

  
  <!--   <mat-list style="max-width: 500px;">
        <mat-list-item>
            <span>test</span>
        </mat-list-item>
    @for (item of this._flowitems; track item.ReportId) {
      @if (item.FlowItemType=='SCREPORT') {
        <mat-list-item style="display: flex;" > -->
<!--             <mat-icon matListItemAvatar src="..." alt="...">

                rate_review
            </mat-icon> -->
         <!--    <app-avatar-circle matListItemAvatar [name]="item.CreatedByFirstName + ' ' + item.CreatedByLastName" backgroundColor="red"></app-avatar-circle>

            <h3 matListItemTitle>{{ item.PlayerLastName}}, {{ item.PlayerFirstName}} 
                     -->
            
            
          <!--   </h3>              
            <span matListItemLine>
             {{item.Text}}
            </span>  -->    
            <!-- <div style="display: flex;"> -->
              <!-- <div [class]="this.classesRankingBox[item.GamePerformance]"></div>{{item.GamePerformanceText}}
              <div [class]="this.classesRankingBoxCapacity[1]"></div>{{item.PlayerCapacityText}} -->
             <!--  <div [class]="this.classesRankingBoxProjection[item.TotalQuality]"></div>{{item.TotalQualityText}} -->
           <!--  </div>   -->
                    
           
          
      <!--   </mat-list-item>
        <mat-divider></mat-divider> -->
   <!--    }
      @if (item.FlowItemType=='PLAYERNOTE') {
       
      }
    }
    </mat-list> -->

<div style="display: flex; flex-direction: column; margin:auto; max-width: 600px; border-left: 1px solid lightgray; padding: 5px;">
 @for (item of this._flowitems; track trackFlowItem(item, $index)) {
      @if (item.FlowItemType=='SCREPORT') {
        <app-report-tight [report]="item" style="margin: 8px;"></app-report-tight>
        <mat-divider></mat-divider>
      }
      @if (item.FlowItemType=='PLAYERNOTE') {
        <app-note-tight [note]="item"></app-note-tight>
        <mat-divider></mat-divider>
      }
      @if (item.FlowItemType!='SCREPORT' && item.FlowItemType!='PLAYERNOTE') {
        <div style="margin: 8px; padding: 8px; border: 1px solid lightgray; border-radius: 6px; background: var(--mat-sys-surface);">
          <div style="font-size: 11px; font-weight: 700; margin-bottom: 4px;">{{ item.FlowItemType }}</div>
          <div style="font-size: 13px;">{{ item.PlayerLastName }}, {{ item.PlayerFirstName }}</div>
          <div style="font-size: 12px; white-space: pre-wrap; margin-top: 4px;">{{ item.Text }}</div>
          <div style="font-size: 11px; opacity: 0.7; margin-top: 4px;">{{ item.DateCreated | date:'yyyy-MM-dd HH:mm' }}</div>
        </div>
        <mat-divider></mat-divider>
      }
    }
</div>
  


